<div class='ContactsListing'>
  <div class='ContactsListing-header'>
    <div class='Breadcrumbs'>
      <div class='Breadcrumbs-items'>
        <a [routerLink]="['/user_contacts', 'user_groups']"
        >
          <mat-icon class='Breadcrumbs-icon back'
          >keyboard_backspace
          </mat-icon
          >
        </a
        >
        <a
          [routerLink]="['/user_contacts', 'user_groups']"
          class='Breadcrumbs-item first'
        >Contacts</a
        >
        <mat-icon class='Breadcrumbs-icon'>chevron_right</mat-icon>
        <span class='Breadcrumbs-item'>{{ groupName }}</span>
      </div>
      <div class='Breadcrumbs-subtitle'>
        <span>({{ totalContactsCount }} contacts found)</span>
      </div>
    </div>
  </div>
  <div class='my-3'>
    <mat-radio-group
      (change)='changeTableFilters($event)'
      [value]='selectedTableFilter' aria-label='Select an user type'>
      <mat-radio-button
        class='me-2'
        value='keyword'
      >Keyword
      </mat-radio-button
      >
      <mat-radio-button
        *ngIf='tagsFilterAvailble'
        class='me-2'
        value='tags'
      >Tags
      </mat-radio-button
      >
    </mat-radio-group>
  </div>
  <div class='ContactsListing-table'>
    <app-table
      #tableComponent
      *ngIf='tableReady'
      [columns]='tableColumns'
      [dataSourceParams]='tableDataSourceParams'
      [dataSource]='dataSource'
      [filterGroups]='tableFilterGroups'
      [useRouteNavigation]='false'>
      <ng-template [appTableMobileRow] let-currentUser='currentUser' let-row='row'>
        <app-contacts-listing-mobile-row (activity)='openActivityDialog($event)' (vip)='toggleContactVip($event)'
                                         [item]='row'></app-contacts-listing-mobile-row>
      </ng-template>
    </app-table>
  </div>
</div>
